function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "careers_5"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "ea541cf9-dc43-4a8f-b3d2-47d07bc39f3f",
  d: "M124 140.23C117.52 96.35 90.83 76 64.36 76S10.49 96.34 4 140.22"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "df828583-aa61-4570-a1c9-2ce5e8d7c68c",
  cx: 64,
  cy: 40,
  r: 36
}), /*#__PURE__*/React.createElement("path", {
  d: "M68 83.23h-8M72.6 130.13l-8.6 10-8.6-10 4.19-35a4.43 4.43 0 014.41-4 4.43 4.43 0 014.41 4z"
}));

var SvgBusiness = function SvgBusiness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 128 144.23",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgBusiness;